<template>
  <div class="bar-chart-scroll">
    <div class="bar-chart-container">
      <canvas ref="canvas"></canvas>
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  name: 'VirtualAssistantEventsCategoryChart',
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateChart() {
      const grouped = {};

      this.events.forEach(event => {
        const dateObj = new Date(event.started_at);

        const key = dateObj.toISOString().split('T')[0];

        if (!grouped[key]) {
          grouped[key] = {
            count: 0,
            label: dateObj.toLocaleDateString('pt-BR', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            }),
          };
        }

        grouped[key].count += 1;
      });

      const sortedKeys = Object.keys(grouped).sort();

      const labels = sortedKeys.map(key => grouped[key].label);
      const data = sortedKeys.map(key => grouped[key].count);
      const hasData = data.some(val => val > 0);

      const finalLabels = hasData
        ? labels
        : [this.$t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.UNKNOWN')];

      const finalDatasets = hasData
        ? [
            {
              label: this.$t(
                'VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.CHART.SESSIONS_PER_DAY'
              ),
              backgroundColor: '#42a5f5',
              data,
            },
          ]
        : [
            {
              label: this.$t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.UNKNOWN'),
              backgroundColor: '#ccc',
              data: [0],
            },
          ];

      this.renderChart(
        {
          labels: finalLabels,
          datasets: finalDatasets,
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                ticks: { fontSize: 12 },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  fontSize: 12,
                  precision: 0,
                },
              },
            ],
          },
          legend: {
            labels: { fontSize: 12 },
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const label = dataset.label || '';
                const value = tooltipItem.value || 0;
                return `${label}: ${Number(value).toLocaleString('pt-BR')}`;
              },
            },
          },
        }
      );
    },
  },
  watch: {
    events: {
      handler() {
        this.updateChart();
      },
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>

<style scoped>
.bar-chart-scroll {
  overflow-x: auto;
  width: 100%;
}

.bar-chart-container {
  position: relative;
  height: 300px;
  width: 100%;
  min-width: 600px;
}
</style>
